import {
	AfterViewInit,
	Component,
	EventEmitter,
	Input,
	OnDestroy,
	Output,
	ViewChild,
	ViewEncapsulation,
} from '@angular/core';
import _cloneDeep from 'lodash/cloneDeep';
import * as html2pdf from 'html2pdf.js';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { PrimeNGConfig } from 'primeng/api';
import { FormioLoader, FormioCustomComponent } from 'dp-formio';
@Component({
	selector: 'pdf-wrapper',
	templateUrl: './pdf-wrapper.component.html',
	// styleUrls: ['./pdf-wrapper.component.scss'],
	encapsulation: ViewEncapsulation.None,
	providers: [FormioLoader],
})
export class PDFWrapperComponent implements FormioCustomComponent<any>, AfterViewInit, OnDestroy {
	dir: 'rtl' | 'ltr';

	@ViewChild('form') form: any;
	@Input() value: any = {};
	@Output() valueChange = new EventEmitter<any>();
	@Output() formSubmitted = new EventEmitter<any>();
	@Input() viewOnly: boolean;
	@Input() data: any;
	@Input() customOptions: any;
	@Input() formioComponent: any;
	disabled: boolean;

	subscriptions$: Subscription[] = [];
	set sub(s: Subscription) {
		this.subscriptions$.push(s);
	}

	constructor(
		private translateService: TranslateService,
		public dialog: MatDialog,
		private primengConfig: PrimeNGConfig
	) {
		this.changeDirection(this.translateService.currentLang);
		this.primengConfig.ripple = true;
	}

	ngAfterViewInit(): void {
		this.sub = this.translateService.onLangChange.subscribe((data) => {
			this.changeDirection(data.lang);
		});
	}

	private changeDirection(lang) {
		this.dir = null;
		setTimeout(() => {
			this.dir = lang == 'ar' ? 'rtl' : 'ltr';
		});
	}

	generatePDF() {
		// $(`#${this.customOptions.containerIdName}`).css('visibility', 'visible');
		// $(`#${this.customOptions.containerIdName}`).height('auto');

		// setTimeout(() => {
		// 	const input = document.getElementById(this.customOptions.containerIdName);
		// 	html2canvas(input).then((canvas) => {
		// 		const imgData = canvas.toDataURL('image/png');
		// 		const pdf = new jsPDF();
		// 		pdf.addImage(imgData, 'PNG', 5, 5, 200, 230);
		// 		pdf.save('download.pdf');

		// 		setTimeout(() => {
		// 			$(`#${this.customOptions.containerIdName}`).css('visibility', 'hidden');
		// 			$(`#${this.customOptions.containerIdName}`).height(0);
		// 		});
		// 	});
		// });

		// Choose the element id which you want to export.
		// var formTemp = document.getElementsByClassName('formio-component-panel2Columns');
		// var summary = document.getElementById('summary');

		const container = document.createElement('div');
		container.classList.add('container');

		var row = document.createElement('div');
		row.classList.add('row');
		container.appendChild(row);

		const col = document.createElement('div');
		col.classList.add('col-12');
		row.appendChild(col);

		let clonedClassContainer: any;
		if (this.customOptions.containerClassName) {
			const classContainer = document.getElementsByClassName(this.customOptions.containerClassName);
			clonedClassContainer = classContainer[0].cloneNode(true);
			col.appendChild(clonedClassContainer);
		}

		let clonedIdContainer: any;
		if (this.customOptions.containerIdName) {
			const idContainer = document.getElementById(this.customOptions.containerIdName);
			clonedIdContainer = idContainer.cloneNode(true);

			if (this.dir === 'rtl') {
				const texts = clonedIdContainer.querySelectorAll(
					'span.transalableSpan, div.transalableSpan'
				);
				texts.forEach((text: any) => {
					text.style.font = 'icon';
					text.style.wordSpacing = '3px';
				});
				// clonedIdContainer.setAttribute('', 'data-html2canvas-ignore');
			}

			col.appendChild(clonedIdContainer);
		}

		// choose the container and pass it to html2pdf() function and call the save() on it to save as pdf.
		html2pdf().set(this.customOptions.pdfOptions).from(container).save();
	}

	ngOnDestroy() {
		this.subscriptions$.forEach((o) => o.unsubscribe());
		this.subscriptions$ = [];
	}
}
